import React from 'react';
import {
  columnDescription,
  columnEnabled,
  columnName,
  hasColumn,
} from '@/constants/fields';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import NameDescriptionColumns from '@/components/table/NameDescriptionColumns';

const ThemesTableColumns = ({ columns = [columnName, columnDescription, columnEnabled] }) => (
  <NameDescriptionColumns columns={columns}>
    {hasColumn(columns, columnEnabled) && (<UnsortedColumn columnId={columnEnabled} />)}
  </NameDescriptionColumns>
);

export default ThemesTableColumns;
